import { getFbAppId } from "../constants/utils";

export const initFbSDK = () => {
    if (!window.fbAsyncInit) {
        window.fbAsyncInit = () => {
            window.FB.init({
                appId: getFbAppId(),
                version: `v11.0`,
                xfbml: true,
            });
        };
    }

    if (document.getElementById('facebook-jssdk')) return;

    ((d, s, id) => {
        const element = d.getElementsByTagName(s)[0];
        const fjs = element;
        let js = element;
        if (d.getElementById(id)) { return }
        js = d.createElement(s); js.id = id;
        js.src = `https://connect.facebook.net/en_US/sdk.js`;
        fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
}


export const loginFB = (type) => {
    return new Promise(async (resolve, reject) => {
        await logoutFB(); // if session terminated explicitly or auth token invalidated.
        window.FB.login(
            (response) => resolve(response.authResponse || null),
            { auth_type: type, scope: 'email' }
        );
    })
}

export const logoutFB = async () => {
    if (window.FB) {

        return new Promise((resolve, reject) => {
            const accessToken = window.FB.getAccessToken();
            if (!accessToken) return resolve(null); // already logged out

            window.FB.api('/me/permissions', 'delete', null, () =>
                window.FB.logout((response) => resolve(response)));
        });
    }
    return;
}

export const getFbUserDetail = () => {
    return new Promise((resolve, reject) => {
        window.FB.api('/me', { fields: 'name,email' }, (userDetail) => {
            resolve(userDetail);
        });
    })
}

export const getFbLoginStatus = () => {
    return new Promise((resolve, reject) => {
        window.FB.getLoginStatus((response) => {
            resolve(response);
        })
    })
}

export const sharePost = (href) => {
    return new Promise((resolve, reject) => {
        window.FB.ui({
            method: 'share',
            href,
            display: 'popup'
        }, (response) => {
            resolve(response);
        });
    });
}